import React from 'react';
import { EventListItem } from '../../components';

const EventList = ({ events, status, handleEdit, handleView, handleDelete, allowViewOnClick }) => {
  return (
    <div className='flex flex-col gap-4 w-full'>
      {(events || [])?.map((event) => (
        <EventListItem
          key={event.id}
          onEdit={() => handleEdit(event.id)}
          onView={() => handleView(event.id)}              
          onDelete={() => handleDelete(event.id)}
          event={event}
          status={status}
          isUnderReview={event?.isUnderReview}
          allowViewOnClick={allowViewOnClick}
        />
      ))}
    </div>
  )
}

export default EventList